import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq({ modern = false }) {
  const { t } = useLang();
  const faqs = t("faqs");
  const heading = modern ? "font-modern" : "font-display";
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 border-t border-[#1A1B18]/10">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#A86946] mb-4">
            {t(modern ? "faq_overline_plain" : "faq_overline")}
          </p>
          <h2 className={`${heading} text-4xl md:text-5xl font-medium tracking-tighter leading-[1.05] mb-12`}>
            {t("faq_title")}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-[#1A1B18]/10">
                <AccordionTrigger
                  data-testid={`faq-q-${i}`}
                  className={`${heading} text-lg md:text-xl font-medium text-left hover:text-[#A86946] hover:no-underline transition-colors`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-a-${i}`}
                  className="text-sm md:text-base text-[#1A1B18]/70 leading-relaxed"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
